import { Component, OnInit, ViewChild } from '@angular/core';
import { MetadataService } from 'src/app/services/metadata.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { Utility, setTimeout$ } from 'src/app/core/common';
import { MetadataType, SourceType } from 'src/app/common';

@Component({
  selector: 'app-manage-skill',
  templateUrl: './manage-skill.component.html',
  styleUrls: ['./manage-skill.component.scss']
})
export class ManageSkillComponent implements OnInit {
  Object = Object;
  MetadataType = MetadataType;
  tab: any = {};
  page: any = { from: 0, limit: 20 };
  _total: number;
  get total() {
    if (this.page.total) this._total = this.page.total;
    return this._total;
  }
  constructor(private spinner: SpinnerService, private metadataService: MetadataService) { }

  async ngOnInit() {
    await this.load(true);
  }

  tabs = [
    { name: MetadataType.Skill, title: 'مهارت های اصلی' },
    { name: MetadataType.WrongSkill, title: 'مهارت های اشتباه' },
    { name: MetadataType.JobTitle, title: 'عناوین شغلی' },
    { name: MetadataType.JobType, title: 'دسته بندی مشاغل' },
  ];
  skills: { [key: string]: number; };
  hasNoVariations: boolean;
  showVerified: boolean;
  search: string;
  order: string;
  minConnections = 10;
  keies: string[];
  _list: any[];
  filtered: any[];
  get list() {
    if (!this._list) return null;
    if (!this.filtered) {
      this.filtered = ((!this.hasNoVariations ? this._list : this._list.filter(_ => !_.Variations || !_.Variations.length)) || []);
      this.filtered = !this.showVerified ? this.filtered : this.filtered.filter(_ => _.IsVerified);
    }
    return this.filtered;
  }

  // sortMetadata = ((a, b) => {
  //   switch (this.order) {
  //     case 'header':
  //       return a.Header < b.Header ? -1 : (a.Header > b.Header ? 1 : 0);
  //     case '-header':
  //       return a.Header < b.Header ? 1 : (a.Header > b.Header ? -1 : 0);
  //     case 'user':
  //       return this.skills.user[a.Header] || 0 - this.skills.user[b.Header] || 0;
  //     case '-user':
  //       return this.skills.user[b.Header] || 0 - this.skills.user[a.Header] || 0;
  //     case 'job':
  //       return this.skills.job[a.Header] || 0 - this.skills.job[b.Header] || 0;
  //     case '-job':
  //       return this.skills.job[b.Header] || 0 - this.skills.job[a.Header] || 0;
  //   }
  // }).bind(this);

  async load(spin = false) {
    if (spin) this.spinner.show('action');

    this.skills = await this.metadataService.getSkills(this.minConnections);
    this._list = (await this.metadataService.search({ IsProcessed: false }));
    this._list.sort((a, b) => {
      switch (this.order) {
        case 'header':
          return a.Header < b.Header ? -1 : (a.Header > b.Header ? 1 : 0);
        case '-header':
          return a.Header < b.Header ? 1 : (a.Header > b.Header ? -1 : 0);
        case 'user':
          return this.skills.user[a.Header] || 0 - this.skills.user[b.Header] || 0;
        default:
        case '-user':
          return (this.skills.user[b.Header] || 0) - (this.skills.user[a.Header] || 0);
        case 'job':
          return this.skills.job[a.Header] || 0 - this.skills.job[b.Header] || 0;
        case '-job':
          return this.skills.job[b.Header] || 0 - this.skills.job[a.Header] || 0;
      }
    });


    this.keies = Utility.distinct([
      ...Object.keys(this.skills.user),
      ...Object.keys(this.skills.job),
      ...Utility.flat(this._list.filter(_ => _.Type == MetadataType.Skill).map(_ => [_.Header, ...(_.Variations || [])]))
    ]).filter(_ => !this._list.find(l => l.Type == MetadataType.WrongSkill && l.Header == _));

    if (spin) this.spinner.hide('action');
    delete this.filtered;
  }

  selected: any;
  @ViewChild('metadataModal') metadataModal: NgxSmartModalComponent;
  @ViewChild('variationModal') variationModal: NgxSmartModalComponent;
  @ViewChild('repairModal') repairModal: NgxSmartModalComponent;

  async open(item: any | MetadataType) {
    if (typeof (item) == 'number')
      this.selected = { Type: item, Variations: [] };
    else
      this.selected = Object.assign({}, item);
    this.metadataModal.open();
    await this.samples();
  }

  sample: { userTotal: number, jobTotal: number, users: any[], jobs: any[] };
  async samples() {
    this.spinner.show('samples');
    delete this.sample;
    if (this.selected.Variations && this.selected.Variations.length)
      this.sample = await this.metadataService.getSamples([this.selected.Header], 10);
    this.spinner.hide('samples');
  }

  async save() {
    this.spinner.show('metadata');

    switch (this.selected.Type) {
      case MetadataType.JobTitle:
      case MetadataType.WrongSkill:
        await this.metadataService.save(this.selected);
        for (var header of this.selected.Variations.filter(_ => !this._list.find(l => l.Type == MetadataType.Skill && l.Header == _)))
          await this.metadataService.save({ Header: header, Type: MetadataType.Skill });
        break;
      case MetadataType.JobType:
      case MetadataType.Skill:
        await this.metadataService.save(this.selected);
        break;
      case -1:
        for (const header of this.selected.Variations) {
          var wrong = this._list.find(l => l.Type == MetadataType.WrongSkill && l.Header == header)
            || { Header: header, Type: MetadataType.WrongSkill, Variations: [] };
          if (!wrong.Variations.includes(this.selected.Header)) {
            wrong.Variations.push(this.selected.Header);
            await this.metadataService.save(wrong);
          }
        }
        break;
    }

    await this.load();
    delete this.selected;
    this.metadataModal.close();
    this.spinner.hide('metadata');
  }

  variateMeta: any = {};
  openVariate(type: MetadataType, from: string) {
    if (type !== MetadataType.WrongSkill) return;
    this.variateMeta = { Header: from, Type: type, Variations: [] };
    this.variationModal.open();
  }

  async variate() {
    this.spinner.show('metadata');

    var list = this._list.filter(_ => _ && _.Variations && _.Variations.some(v => v == this.variateMeta.Header));
    for (const metadata of list) {
      var index = metadata.Variations.findIndex(_ => _ == this.variateMeta.Header);
      if (index >= 0) metadata.Variations.splice(index, 1, ...this.variateMeta.Variations);
      await this.metadataService.save(metadata);
    }
    if (!this._list.find(_ => _.Header == this.variateMeta.Header))
      await this.metadataService.save(this.variateMeta);

    await this.load();
    this.variationModal.close();
    this.spinner.hide('metadata');
  }

  async delete(id: string) {
    this.spinner.show('action');
    await this.metadataService.delete(id);
    await this.load();
    this.spinner.hide('action');
  }

  async process(metadata: any) {
    this.spinner.show('action');
    await this.metadataService.process(metadata.Id);
    await this.load(true);
    this.spinner.hide('action');
  }
  async processAll(type = MetadataType.WrongSkill) {
    this.spinner.show('action');
    await this.metadataService.process(...this._list.filter(_ => _.Type == type && _.IsVerified && !_.IsProcessed).map(_ => _.Id));
    await this.load();
    this.spinner.hide('action');
  }
  async removeProcessed(type = MetadataType.WrongSkill) {
    this.spinner.show('action');
    await this.metadataService.delete(...this._list.filter(_ => _.Type == type && _.IsProcessed).map(_ => _.Id));
    await this.load();
    this.spinner.hide('action');
  }
  async verify(metadata: any) {
    metadata.IsVerified = !metadata.IsVerified;
    await this.metadataService.save(metadata);
  }

  statuses(key: string) {
    if (!this._list) return [];
    var res = [];
    if (this._list.find(_ => _.Type == MetadataType.Skill && _.Header == key))
      res.push('اصلی');
    if (this._list.find(_ => _.Type == MetadataType.Skill && _.Variations && _.Variations.includes(key)))
      res.push('مشابه');
    if (this._list.find(_ => _.Type == MetadataType.WrongSkill && _.Header == key))
      res.push('اشتباه');
    if (this._list.find(_ => _.Type == MetadataType.WrongSkill && _.Variations && _.Variations.includes(key)))
      res.push('جایگزین');

    return res;
  }

  add(event: Event, header: string, type: MetadataType) {
    setTimeout$(async () => {
      if (type == MetadataType.WrongSkill) {
        this.keies.splice(this.keies.findIndex(_ => _ == header), 1);
        this.keies = [...this.keies];
      }

      await this.metadataService.save({ Header: header, Type: type });
      await this.load();
    });
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  getSource(job: any) {
    return `${this.getSourceType(job)}: ${job.SourceName || ''}`;
  }
  getSourceType(job: any) {
    switch (job.SourceType) {
      case SourceType.Website: return 'وبسایت';
      case SourceType.Telegram: return 'تلگرام';
      case SourceType.Instagram: return 'اینستاگرام';
      case SourceType.Agent: return 'کاریابی';
      case SourceType.Karpishe: return 'کارپیشه';
      case SourceType.Special: return 'ویژه';
    }
    return '';
  }

  setOrder(order: string) {
    this.order = this.order == order ? `${order}-` : order;
    delete this.filtered;
  }

  duplicates: string[];
  async removeDuplicates() {
    this.spinner.show('action');
    if (!this.duplicates) setTimeout$(() => {
      this.duplicates = [];
      for (const item of this._list)
        if (this._list.find(_ => !this.duplicates.includes(_.Id) && item.Type == _.Type && item.Header == _.Header && item.Id != _.Id &&
          Utility.equal(item.Variations, _.Variations)))
          this.duplicates.push(item.Id);
      this.spinner.hide('action');
    });
    else {
      if (this.duplicates.length) {
        await this.metadataService.delete(...this.duplicates);
        await this.load();
      }
      delete this.duplicates;
      this.spinner.hide('action');
    }
  }

  repairMeta: any = {};
  async repair() {
    this.spinner.show('repair');
    await this.metadataService.repair(this.repairMeta);
    await this.load();
    this.repairModal.close();
    this.spinner.hide('repair');
  }

  reordering: boolean;
  index(key: string) { return (<string[]>this.selected.Variations).indexOf(key); }
  up(key: string) {
    this.reordering = true;
    var index = this.index(key);
    (<string[]>this.selected.Variations).splice(index, 1);
    (<string[]>this.selected.Variations).splice(index - 1, 0, key);
    setTimeout$(() => delete this.reordering);
  }
  down(key: string) {
    this.reordering = true;
    var index = this.index(key);
    (<string[]>this.selected.Variations).splice(index, 1);
    (<string[]>this.selected.Variations).splice(index + 1, 0, key);
    setTimeout$(() => delete this.reordering);
  }
}
